import React, { useEffect } from 'react';
import { useState } from 'react';
import { useAlert } from 'react-alert';
import { Carousel, Modal } from 'react-bootstrap';
import '../../assets/css/newRegistration.css';
import api from '../../seller-apis/api';
import { pendforapprovProducts, pendingProducts } from '../../seller-apis/apidataField';
import { useHistory } from 'react-router-dom';


const NewRegistration = () => {
    const history = useHistory();
    const alert = useAlert();

    const [gstNo, setGstNo] = useState("")
    const [mobile, setMobile] = useState("")
    const [email, setEmail] = useState("")
    const [companyName, setCompanyName] = useState("")
    useEffect(() => {
        // window.history.pushState({}, null, '/');
        history.replace('/');
        return false;
        if (localStorage.getItem('token')) {
          api.auth.me().then(res => {
            if (res.data && res.data.activeState && res.data.activeState === "InActive") {
              localStorage.clear()
            }
            else {
              localStorage.setItem('image', res.data.avatar);
              localStorage.setItem('phone', res.data.phoneNumber)
              localStorage.setItem('userId', res.data._id)
              localStorage.setItem('email', res.data.email)
              localStorage.setItem("vendorId", res.data._id)
              localStorage.setItem('gst', res.data.gstNo)
              localStorage.setItem('vendorType', res.data.vendorType ? res.data.vendorType:undefined)
              localStorage.setItem('vendorState', res.data.activeState)
              if (res.message === "Seller Not Activated") {
    
                let totalPro = 0
                // Pending products
                let filter = {
                  "pageNo": "1",
                  "size":1
                }
    
    
                api.product.newProductsRetrieveall(pendingProducts(filter))
                  .then((res) => {
                    totalPro = totalPro + res.totalRecords
    
                    // New request for approval Products
                    api.product.vExPrdReqRetrieveAll(pendforapprovProducts(filter))
                      .then((res) => {
                        totalPro = totalPro + res.totalRecords
                        if (totalPro > 0) {
                          window.history.pushState({}, null, '/homenew');
                          window.location.assign('/homenew')
                        }
                        else {
                          window.history.pushState({}, null, '/register/3');
                          window.location.assign('/register/3')
                        }
                      })
                      .catch(err => console.log(err))
                  })
                  .catch(err => console.log(err))
              }
              else if (res.message === "seller fetched") {
                window.location.assign('/home')
              }
              else {
                localStorage.clear()
              }
            }
          }).catch(err => {
            if(err.response && err.response.statusText === "Unauthorized"){
              window.location.assign('/session_expired')
            }}
            );
        }
      }, [])
    
    const [show, setShow] = useState(false)

    const handleClose = () => {
        setShow(false)
    }

    async function regSeller() {
        let isGstVerified;
        if (mobile === "" || mobile === undefined || mobile.length < 10) {
            alert.info("Please enter a valid Mobile no.");
        }
        else if (email === "" || email === undefined || !email.includes("@")) {
            alert.info("Please enter a valid email address");
        }
        else if (companyName === "" || companyName === undefined) {
            alert.info("Please enter Company Name.");
        }
        else {
            isGstVerified = await verifyGst();
            console.log(isGstVerified)
            if (isGstVerified) {
                sessionStorage.setItem("reg_Mobile", mobile)
                sessionStorage.setItem("reg_Mail", email)
                sessionStorage.setItem("reg_CompanyName", companyName)
                sessionStorage.setItem("reg_Gst", gstNo)
                window.location.assign('/register/2')
            }
        }
    }


    // Verify gst 
    function verifyGst() {
        return new Promise((resolve, reject) => {
            let isOk;
            if (gstNo === "" || gstNo === undefined) {
                alert.info("Please enter your GST no.")
                isOk = false;
                resolve(isOk);
            }
            else {
                console.log(gstNo)
                const regex = new RegExp("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$");
                if (regex.test(gstNo.toUpperCase())) {

                    let registrationdata = {
                        "gstNo": gstNo.toUpperCase()
                    }
                    api.auth.registerSeller(registrationdata)
                        .then((res) => {
                            console.log(res)
                            if (res.data.message === "Vendor registerd") {
                                localStorage.clear()
                                localStorage.setItem("gst", gstNo.toUpperCase());
                                localStorage.setItem('vendorId', res.data.data)
                                isOk = true;
                                resolve(isOk);
                            }
                            else {
                                alert.info(res.data.message)
                                isOk = false;
                                resolve(isOk);
                            }
                        }).catch((err) => {
                            console.log(err)
                            isOk = false;
                            resolve(isOk);
                        })
                }
                else {
                    console.log(gstNo)
                    alert.info("Please enter correct GST no.")
                    isOk = false;
                    resolve(isOk);
                }
            }
        })
    }


    function handleSellerSupport() {
        let ele = document.createElement('a');
        ele.href = "mailto:sellersupport@toolsvilla.com"
        ele.click();
        ele.remove()
    }

    return (
        <div className='new_Registration_Cntn'>

            {/* Header */}
            <div className='n_Reg_Header d-flex' id="first_panel">
                <div className='n_Reg_Header_logo w-50'>
                    <img className='' src='./reg_header_logo.png' alt='img'></img>
                </div>
                <div className='n_Reg_Header_buttons w-50 m-auto'>
                    <button className='n_Reg_Header_buttons_ft' onClick={() => window.open("https://play.google.com/store/apps/details?id=com.toolsvilla.seller", "_blank")}><i className="fa fa-mobile me-1" aria-hidden="true"></i> Download App</button>
                    <button className='n_Reg_Header_buttons_ft' onClick={() => window.location.assign('/login')}>
                        <i className="fa fa-user me-1" aria-hidden="true"></i> Log In</button>
                    <button className='n_Reg_Header_buttons_lb' onClick={() => setShow(true)}>Seller Support</button>
                </div>
            </div>

            {/* 1 section */}
            <div className='n_Reg_first_cntn'>
                <div className='n_Reg_first_form'>
                    <div className='n_Reg_first_form_head'>
                        <h4 className=''>Register To Become a Seller</h4>
                        <h6>Create your account now</h6>
                    </div>
                    <div className='n_Reg_first_form_input'>
                        <span className=''>+ 91 |</span>
                        <input type='number' className='n_Reg_first_form_input_m_no' placeholder='Mobile No*' onInput={(e) => e.target.value = e.target.value.slice(0, 10)} value={mobile} onChange={(e) => setMobile(e.target.value)} onWheel={(e) => e.target.blur()} />
                        <input type='text' placeholder='GSTIN*' value={gstNo} onChange={(e) => setGstNo(e.target.value)} />
                        <input type='email' placeholder='Email ID*' value={email} onChange={(e) => setEmail(e.target.value)} />
                        <input type='text' placeholder='Company Name*' value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                    </div>
                    <div className='n_Reg_first_form_foot'>
                        <input type='checkbox' id="n_Reg_first_checkboxid" className='mt-2 n_Reg_first_checkbox'></input>
                        <label className='ms-2 fs-14 n_Reg_first_label' for="n_Reg_first_checkboxid">I want to receive important updates on Whatsapp</label>
                        <br></br>
                        <button onClick={() => regSeller()}>Create Account</button>
                    </div>
                </div>
                <img src='./registration_2.png' className='' alt='img'></img>

            </div>

            {/* 2 section */}
            <div className='n_Reg_second_cntn restration-desk'>
                <img src='./registration_1.png' className='' alt='img'></img>
            </div> 
            <div className='n_Reg_second_cntn  restration-mob' style={{display:'none'}}>
                <img src='./registration_1_mob.png' className='' alt='img'></img>
            </div>

            {/* 3 section */}
            <div className='n_Reg_third_cntn'>
                <div className='n_Reg_third_first'>
                    <div className=''>
                        <p> 6 Simple Steps </p>
                        <p> to Start Your Business</p>

                    </div>
                    <div className=''>
                        <img src="./arrow-down.png" />
                    </div>
                </div>
                <div className='n_Reg_third_cards_cntn'>
                    <div className='n_Reg_third_cards'>
                        <img src='./r_des_3card_1.png' alt="img"></img>
                    </div>
                    <div className='n_Reg_third_cards'>
                        <img src='./r_des_3card_2.png' alt="img"></img>
                    </div>
                    <div className='n_Reg_third_cards'>
                        <img src='./r_des_3card_3.png' alt="img"></img>
                    </div>
                    <div className='n_Reg_third_cards'>
                        <img src='./r_des_3card_4.png' alt="img"></img>
                    </div>
                    <div className='n_Reg_third_cards'>
                        <img src='./r_des_3card_5.png' alt="img"></img>
                    </div>
                    <div className='n_Reg_third_cards'>
                        <img src='./r_des_3card_6.png' alt="img"></img>
                    </div>

                </div>
            </div>

            {/* 4 section */}
            <div className='n_Reg_fourth_cntn'>
                <div className=''>
                    What makes people love Toolsvilla
                </div>
                <div className='n_Reg_fourth_card_cntn'>
                    <Carousel className='my-4 carousel text-center' pause="hover">
                        <Carousel.Item className="video">
                            <img src='./reg_review1.png' alt='img'></img>
                        </Carousel.Item>
                        <Carousel.Item className="video">
                            <img src='./reg_review2.png' alt='img'></img>
                        </Carousel.Item>
                        <Carousel.Item className="video">
                            <img src='./reg_review3.png' alt='img'></img>
                        </Carousel.Item>
                        {/* <Carousel.Item className="video">
                            <img src='./reg_review4.png' alt='img'></img>
                            <img src='./reg_review5.png' alt='img'></img>
                            <img src='./reg_review6.png' alt='img'></img>
                        </Carousel.Item> */}
                    </Carousel>

                </div>
            </div>


            {/* 5 section */}
            <div className='n_Reg_fifth_cntn'>
                <div className='row'>
                    <div className='col-4'>
                        <div className='d-flex m-auto'>
                            <div className='n_Reg_fifth_foot_logo'>
                                <img src='./logo-search.png' alt='image' />
                            </div>
                            <div className='n_Reg_fifth_foot_logo_text'>
                                <span className='n_Reg_fifth_foot_logo_text_1'>TOOLSVILLA</span>
                                <br></br>
                                <span className='n_Reg_fifth_foot_logo_text_2'>Sell on India’s leading B2B
                                    E-commerce Marketplace</span>
                            </div>
                        </div>
                        <div className='n_Reg_fifth_cntn_logo_btn'>
                            <button onClick={() => document.getElementById('first_panel').scrollIntoView()}>START SELLING</button>
                        </div>
                    </div>
                    <div className='col-1'>
                        {/* <p className='n_Reg_fifth_heading'>Quick Links</p>
                        <ul className='n_Reg_fifth_ul n_Reg_fifth_ul_quicklinks'>
                            <li><NavLink exact to="/">Login</NavLink></li>
                            <li><NavLink exact to="/">How it works</NavLink></li>
                            <li><NavLink exact to="/">Shipping & Returns</NavLink></li>
                            <li><NavLink exact to="/">Terms & Conditions</NavLink></li>
                            <li><NavLink exact to="/">Privacy Policy</NavLink></li>
                            <li><NavLink exact to="/">Learning centre</NavLink></li>
                        </ul> */}
                    </div>
                    <div className='col-4'>
                        <p className='n_Reg_fifth_heading'>Contact</p>
                        <ul className='n_Reg_fifth_ul n_Reg_fifth_ul_contacts'>
                            <li><a href="mailto:sellersupport@toolsvilla.com">sellersupport@toolsvilla.com</a></li>
                        </ul>
                    </div>
                    <div className='col-3 d-flex justify-content-center'>
                        <div className='n_Reg_fifth_cntn_social_icons'>
                            <img src='./yt_rg_icon.png' alt='image' onClick={() => window.open(" https://www.youtube.com/@toolsvilla_tv", "_blank")} />
                        </div>
                        <div className='n_Reg_fifth_cntn_social_icons'>
                            <img src='./fb_rg_icon.png' alt='image' onClick={() => window.open("https://www.facebook.com/toolsvilla/", "_blank")} />
                        </div>
                        <div className='n_Reg_fifth_cntn_social_icons'>
                            <img src='./in_rg_icon.png' alt='image' onClick={() => window.open("https://www.instagram.com/toolsvilla/?hl=en", "_blank")} />
                        </div>
                        {/* <div className='n_Reg_fifth_cntn_social_icons'>
                            <img src='./li_rg_icon.png' alt='image' onClick={() => window.open("https://www.facebook.com/toolsvilla/", "_blank")} />
                        </div> */}
                    </div>
                </div>
                <div className='n_Reg_fifth_cntn_copyright'>
                    <p>Copyright @2022 toolsvilla</p>
                </div>
            </div>


            {/* Popup for seller support */}

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size='lg'
                className="seller_sup_modal"
            >
                <Modal.Header className='seller_sup_modal_header me-2' closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body className='seller_sup_modal_body'>
                    <div className='row'>
                        <div className='col-4'>
                        <img src='./seller-sup_icon3.jpg' className='w-80' alt="img"/>
                        </div>
                        <div className='col-8'>
                            <p className='seller_sup_he11'>Toolsvilla Seller Support</p>
                            <p className='seller_sup_p11'>Whether you're just starting out or you've been in the business for a long time, we're here to help you with all your questions.</p>
                           <div className='seller_sup_d'>
                           <p className='seller_sup_p12'>Reach us at</p>
                           <div className='seller_sup_d1_p12'>

                           </div>
                           </div>
                            <p className='seller_sup_p13'>
                                <span> <img src='./seller-sup_icon2.jpg' alt='img' className='seller_sup_p13_img'/> sellersupport@toolsvilla.com </span>
                                <span className='ms-4'><img src='./seller-sup_icon1.jpg' alt='img' className='seller_sup_p13_img'/>  +91 9986646883</span> </p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default NewRegistration